<!-- 打印采购单-迪索里克 -->
<template>
    <div v-loading="loading" style="position: relative">
        <div id="printPurContent" class="print-zone">
            <div style="width: 763px; margin: 0 auto">
                <div id="top">
                    <div class="print-title-view">
                        <div class="order-code">
                            <canvas id="canvas" class="qrcode-canvas" ref="canva"></canvas>
                            <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" />
                        </div>
                        <div v-if="isEditTitle" class="print-title">
                            <el-input type="text" style="width: 70%" v-model="titleConfig.RValue"></el-input>
                        </div>
                        <div v-else class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : titleConfig.RValue }}</div>
                        <div class="order-detail">
                            <div class="right">单号：{{ orderData.OrderCode }}</div>
                            <div class="right">
                                日期：
                                <span>{{ orderData.CreateTime }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="table_b">
                    <table
                        border="1"
                        cellspacing="0"
                        cellpadding="1"
                        width="100%"
                        style="border-collapse: collapse; table-layout: fixed; border-bottom: none"
                        bordercolor="#333333"
                    >
                        <thead>
                            <tr style="font-weight: bold">
                                <td width="20%" style="border-bottom: none">供应商名称</td>
                                <td width="80%" style="border-bottom: none">{{ orderData.EntpCusName }}</td>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div id="table">
                    <table border="1" cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse; table-layout: fixed" bordercolor="#333333">
                        <thead>
                            <tr style="font-weight: bold">
                                <td width="5%">
                                    <div><b>序</b></div>
                                </td>
                                <td width="15%">
                                    <div><b>汽配编码</b></div>
                                </td>
                                <td width="15%">
                                    <div><b>互换码</b></div>
                                </td>
                                <td width="15%">
                                    <div><b>汽配名称</b></div>
                                </td>
                                <td width="22%">
                                    <div><b>车型</b></div>
                                </td>
                                <td width="8%">
                                    <div><b>数量</b></div>
                                </td>
                                <td width="10%">
                                    <div><b>单位</b></div>
                                </td>
                                <td width="10%">
                                    <div><b>采购价</b></div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="index" v-for="(AP, index) in orderData.DetailList">
                                <td>{{ Number(index) + 1 }}</td>
                                <td>{{ AP.APCode }}</td>
                                <td>{{ AP.GoodCode }}</td>
                                <td>{{ AP.GoodName }}</td>
                                <td style="white-space: nowrap; text-overflow: clip; overflow: hidden">{{ AP.AutoSerise }}</td>
                                <td>{{ AP.Count }}</td>
                                <td>{{ AP.Unit }}</td>
                                <td>{{ AP.Price }}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style="text-align: right">总数量：</td>
                                <td>{{ orderData.TotalCount }}</td>
                                <td style="text-align: right">总价：</td>
                                <td>{{ allPrice }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <div class="sort-set"></div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printPurContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        },
        printType: {
            type: Number,
            default: 0
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: userMsg.EntpName,
            imgUrl: '',
            tableData: [],
            isPreview: false,
            isDefaultSet: false,
            sortField: '',
            orderData: {},
            loading: false,
            isEditTitle: false, //编辑标题
            titleConfig: {
                RValue: userMsg.EntpName + '采购单'
            }, //标题配置
            isPrint: false
        };
    },
    watch: {
        orderData(value) {
            if (this.imgUrl || !this.isInit) return;
            this.$nextTick(function () {
                let canvas = this.$refs.canva;
                QRCode.toCanvas(
                    canvas,
                    value.OrderCode,
                    {
                        width: 80,
                        height: 80,
                        margin: 0,
                        scrollX: 0,
                        scrollY: 0
                    },
                    function (error) {}
                );
                setTimeout(() => {
                    html2canvas(canvas, {
                        width: 80,
                        height: 80,
                        scrollX: 0,
                        scrollY: 0
                    })
                        .then(canvasRes => {
                            var imgData = canvasRes.toDataURL('image/png');
                            this.imgUrl = imgData;
                            canvas.style.display = 'none';
                        })
                        .catch(error => {});
                }, 1000);
            });
        }
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.orderData = {};
            this.getConfigByCodes().then(() => {
                this.getOrder();
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyyl', 'syllqdysz'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let topStyle = `
                    .print-title-view {
                        width: 762px;
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-end;
                        padding: 12px 0;
                    }
                    .print-title {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        max-width: 50%;
                        margin: 0 auto;
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                    }                    
                    .order-detail {
                         color: #000;
                    }
                    .order-code {
                        width: 80px;
                        height: 80px;
                        display: inline-block;
                        vertical-align: top;
                    }
                    .qrcode-canvas,.qrcode-image{
                        display:none;
                    }                   
               `;
                var tableStyle = `
                    table,
                    td,
                    th {
                        border-width: 1px;
                        border-style: solid;
                        border-collapse: collapse;
                        color: #000;
                        padding-bottom: 3px;
                        padding-top: 3px;
                        padding-left: 2px;                        
                    }
                     /* 为了兼容火狐不换行 */
                    td{
                        word-break : break-all;word-wrap: break-word;
                    }                    
                    table{
                        border-top: solid 1px black;
                        border-bottom: 0px;
                        border-left: 0px;
                        border-right: 0px;                       
                    }
                    tfoot td {
                        font-weight: bold;
                        border: 0;
                    }                
                `;

                let footStyle = `
                    .order-remark {
                        width: 742px;
                        display: -webkit-flex;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        margin-left: 10px;
                        margin-right: 10px;
                        padding-top: 5px;
                        color: #000;
                    }                     
                    .fwb {
                        font-weight: bold;
                        font-size:16px;
                    }
                    .btd {
                        border-bottom: 1px dashed #000;
                        font-weight: bold;
                    }                                
                `;

                let contentHeight = document.getElementById('printPurContent').clientHeight;
                let topHeight = document.querySelector('#printPurContent #top').clientHeight;
                let table_b_Height = document.querySelector('#printPurContent #table_b').clientHeight;
                let tableHeight = document.querySelector('#printPurContent #table').clientHeight;
                // let footHeight = document.querySelector('#printPurContent #foot').clientHeight;

                LODOP.ADD_PRINT_BARCODE(10, 1, 100, 100, 'QRCode', this.orderData.OrderCode);
                LODOP.SET_PRINT_STYLEA(0, 'QRCodeVersion', 3);
                LODOP.SET_PRINT_STYLEA(0, 'QRCodeErrorLevel', 'L');
                if (contentHeight <= 1080) {
                    // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', '');
                    // //隐藏页尾
                    tableStyle += 'tfoot{display:none;}';
                }
                LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${topStyle}</style>` + document.querySelector('#printPurContent #top').innerHTML);
                LODOP.ADD_PRINT_TABLE(topHeight + 3, 0, '100%', `BottomMargin:0px`, `<style>${tableStyle}</style>` + document.querySelector('#printPurContent #table_b').innerHTML);
                // LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);

                LODOP.ADD_PRINT_TABLE(
                    topHeight + table_b_Height,
                    0,
                    '100%',
                    `BottomMargin:0px`,
                    `<style>${tableStyle}</style>` + document.querySelector('#printPurContent #table').innerHTML
                );
                //次页开始的上边距偏移量
                LODOP.SET_PRINT_STYLEA(0, 'Offset2Top', -topHeight - table_b_Height + 5);
                // LODOP.ADD_PRINT_HTM('0', '0', '100%', '100%', `<style>${footStyle}</style>` + document.querySelector('#printPurContent #foot').innerHTML);
                // LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', -1);
                // LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord(
                    {
                        OrderId: this.printIds[0].id,
                        Type: 2
                    },
                    true
                )
                .then(() => {
                    this.isPrint = true;
                    this.loading = false;
                    if (!this.isInit) this.$emit('closeDialog', true);
                })
                .finally(res => {
                    this.loading = false;
                });
        },
        // 取消
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        // 获取表格数据
        getOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetHKPurOrderPrint',
                    data: {
                        EntpCusPOId: this.printIds[0].id
                    },
                    hideLoading: this.isInit
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    let data = res.data;
                    this.orderData = res.data;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrice += Number(DetailList[i].Count) * DetailList[i].Price;
                    }
                    this.allNum = _allNum;
                    this.allPrice = _allPrice.toFixed(2);
                    let that = this;
                    if (that.isInit) that.loading = false;
                    else {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                that.lodopPrint();
                            }, 100);
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        setSortField(field) {
            this.getOrder();
        }
    }
};
</script>
<style lang="less">
.fkyou {
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom: 1px solid #000;
    margin-bottom: 0px;
}
.fkyou td {
    padding: 0;
    border-right: 1px solid #000;
    border-top: 1px solid #000;
}
.fkyou th {
    padding: 0;
    border: 1px solid #000;
}

.fkyou div {
    color: #000;
}
</style>
<style lang="less" scoped media="print">
.el-row {
    margin-bottom: 0;
}
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px 0;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding-top: 5px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}

.print-table-main {
    width: 792px;
    margin-left: 1px;
    font-size: 12px;
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 11px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
        margin: 0;
    }
    .row {
        border-top: 1px solid #000;
    }
}
.btn-ctn-left {
    display: flex;
}
.fullCut {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fdzt {
    font-size: 14px;
}
table,
td,
th {
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
}
tfoot {
    display: none;
}
</style>
